import { render, staticRenderFns } from "./ResellerProfile.vue?vue&type=template&id=3e47173a&scoped=true&"
import script from "./ResellerProfile.vue?vue&type=script&lang=js&"
export * from "./ResellerProfile.vue?vue&type=script&lang=js&"
import style0 from "./ResellerProfile.vue?vue&type=style&index=0&id=3e47173a&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e47173a",
  null
  
)

export default component.exports